export const nav = {
    permission: 'ata.sectors:ver',
    section: 'Minutes',
    title: 'Sectors',
    icon: 'apartment',
    route: '/sectors',
    sequence: 12,
};

export default [
    {
        path: '/sectors',
        name: 'sectors',
        component: () => import('./pages/SectorsPage.vue'),
        meta: { requiresAuth: true, permission: 'ata.sectors:ver' },
    },
    {
        // Dentro de Setores: sem item de menu proprio (o acesso e pelo botao da linha do setor).
        path: '/sectors/:sectorId/users',
        name: 'sectorUsers',
        component: () => import('./pages/SectorUsersPage.vue'),
        meta: { requiresAuth: true, permission: 'ata.sectors:users' },
    },
];
